// extracted by mini-css-extract-plugin
module.exports = {"cell":"_927a99ad28--cell--WxQ7q","cell_header":"_927a99ad28--cell_header--Go1hx"};